export const SET_PUBLIC_QUESTION = 'ROOM/PUBLIC_QUESTION/SET_PUBLIC_QUESTION'
export const SET_PUBLIC_QUESTIONS = 'ROOM/PUBLIC_QUESTION/SET_PUBLIC_QUESTIONS'
